import { Link } from '@remix-run/react';
import { Grid, Label, Button, useStyles } from '@archipro-design/aria';
import {
    NarrowContent,
    VideoContent,
} from '@modules/articles/component/page-layout/PageLayout.style';
import type { LatestArticlesProps } from '@modules/articles/component/latest-articles/LatestArticles';
import {
    FILMS_CATEGORY_LINK,
    IMAGE_WIDTH_GRID_3,
} from '@modules/articles/config/constants';
import ArticleVideoTile from '@modules/articles/component/article-video-tile/ArticleVideoTile';
import * as S from './LatestArticles.style';
import { useTileHotButtons } from '~/modules/root';

interface LatestArticlesDesktopProps extends LatestArticlesProps {
    showCategory?: boolean;
}

const LatestArticlesDesktop = ({
    latestArticles,
    title,
    loadMoreLink,
    useFilmsLayout,
    showCategory,
}: LatestArticlesDesktopProps) => {
    const { css } = useStyles();

    const articleIDs = latestArticles.map((article) => article.ID);

    const { getTileTopActions, hotButtonModal } = useTileHotButtons({
        itemType: 'article',
        itemIDs: articleIDs,
    });

    return (
        <div className={css(useFilmsLayout ? VideoContent : NarrowContent)}>
            <div className={css(S.Wrap)}>
                <div className={css(S.TitleWrap)}>
                    <Label variant="01">{title}</Label>
                </div>
                <Grid className={css(S.TileGrid)} columns={3}>
                    {latestArticles.map((article) => {
                        if (useFilmsLayout) {
                            article.variant = '07';
                            article.size = 'medium';
                        }
                        return (
                            <ArticleVideoTile
                                key={`archizeen_tile_container--${article.ID}`}
                                article={article}
                                imageWidth={IMAGE_WIDTH_GRID_3}
                                showCategory={showCategory}
                                getTileTopActions={getTileTopActions}
                            />
                        );
                    })}
                </Grid>
                {loadMoreLink && (
                    <div className={css(S.LoadMore)}>
                        <Button
                            size={16}
                            as={Link}
                            to={FILMS_CATEGORY_LINK}
                            prefetch="intent"
                        >
                            View More
                        </Button>
                    </div>
                )}
            </div>
            {hotButtonModal}
        </div>
    );
};

export default LatestArticlesDesktop;
